import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import {
  LiveUpdatesCreateSocketResponse,
  LiveUpdatesSubscriptionQuery,
} from './live-updates.model';

@Injectable()
export class LiveUpdatesApi {
  constructor(private clientService: ClientService) {}

  createSubscription(
    subscriptions: LiveUpdatesSubscriptionQuery[]
  ): Observable<LiveUpdatesCreateSocketResponse> {
    const endpoint = `live-updates/v1/iot`;
    return this.clientService.post(endpoint, { subscriptions });
  }

  updateSubscription(
    subscriptions: LiveUpdatesSubscriptionQuery[],
    socketId: string
  ): Observable<LiveUpdatesCreateSocketResponse> {
    const endpoint = `live-updates/v1/iot/${socketId}`;

    return this.clientService.patch(endpoint, { subscriptions });
  }
}
